

<script>
import VP from "@/services/ViewportService";

export default {
	name: "DualTable",
	props: {
		leftLabel: { type: String, default: "Left Table" },
		leftSearch: { type: String, default: "" },
		leftItems: {
			default: () => {
				return [];
			}
		},
		leftFields: { type: Array, default: [] },
		leftControl: {
			type: Object,
			default: {
				totalRows: 0,
				currentPage: 1,
				perPage: 20,
				filter: "",
				sortBy: "",
				sortDesc: false,
				busy: false
			}
		},
		rightLabel: { type: String, default: "Right Table" },
		rightSearch: { type: String, default: "" },
		rightItems: {
			default: () => {
				return [];
			}
		},
		rightFields: { type: Array, default: [] },
		rightControl: {
			type: Object,
			default: {
				totalRows: 0,
				currentPage: 1,
				perPage: 20,
				filter: "",
				sortBy: "",
				sortDesc: false,
				busy: false
			}
		}
	},
	data() {
		return {
			conditionalFooter: []
		};
	},

	created() {
		// this.resizeFunc = _.debounce(() => {
		// 	if (VP.inBreakpoint("xl")) {
		// 		VP.resizeBTable(
		// 			"leftContainer",
		// 			38.4 + 40 + 52.6,
		// 			39.2,
		// 			this.leftControl
		// 		);
		// 		VP.resizeBTable(
		// 			"rightContainer",
		// 			38.4 + 40 + 52.6,
		// 			39.2,
		// 			this.rightControl
		// 		);
		// 	} else {
		// 		this.leftControl.perPage = 10;
		// 		this.rightControl.perPage = 10;
		// 		this.$forceUpdate();
		// 	}
		// }, 250);
		// this.resizeFunc = _.debounce(() => {
		// 	if (VP.inBreakpoint("xl")) {
		// 		console.log("DO FOOTER");
		// 		this.conditionalFooter = ["page-footer"];
		// 	} else {
		// 		console.log("DON'T FOOTER");
		// 		this.conditionalFooter = [];
		// 	}
		// }, 250);
		// window.addEventListener("resize", this.resizeFunc);
	},

	destroyed() {
		// window.removeEventListener("resize", this.resizeFunc);
	},

	render(h) {
		return (
			<div class="flex d-flex flex-column">
				<div class="flex d-flex flex-row flex-wrap">
					{this.renderTable(h, "left")}
					{this.renderTable(h, "right")}
				</div>
			</div>
		);
	},
	methods: {
		renderTable(h, prefix) {
			var label = this[`${prefix}Label`];
			var search = this[`${prefix}Search`];
			var items = this[`${prefix}Items`];
			var fields = this[`${prefix}Fields`];
			var control = this[`${prefix}Control`];
			var scopedSlots = {};
			_.each(this.$scopedSlots, (slot, slotName) => {
				var slotName = slotName.split(":");
				if (slotName[0] == prefix) {
					scopedSlots[slotName[1]] = slot;
				}
			});
			var conditionalFooter = [];
			// if (VP.inBreakpoint("xl")) {
			// 	conditionalFooter.push("page-footer");
			// }

			return (
				<div id={`${prefix}Container`} class="pt-2 px-0 flex b-t b-r d-flex flex-column">
					<div class="flex-grow flex-shrink scroll-y">
						<b-table
							class="mb-0"
							ref={`${prefix}Table`}
							id={`${prefix}Table`}
							striped
							hover
							showEmpty={true}
							items={items}
							fields={fields}
							currentPage={control.currentPage}
							perPage={control.perPage}
							filter={control.filter}
							sortBy$sync={control.sortBy}
							sortDesc$sync={control.sortDesc}
							emptyText={control.emptyText}
							//busy$sync={control.busy}
							scopedSlots={scopedSlots}
						/>
					</div>
					<div
						id={`${prefix}Pages`}
						class="no-grow no-shrink p-1 b-t mt-auto white d-flex flex-row align-items-center"
						{...{ class: conditionalFooter }}
					>
						<a class="flex mx-3">
							Page {control.totalRows > 0 ? control.currentPage : 0} of{" "}
							{Math.ceil(control.totalRows / control.perPage)} ({control.totalRows})
						</a>
						<div>
							<b-pagination
								size="md"
								class="m-1"
								totalRows={control.totalRows}
								v-model={control.currentPage}
								perPage={control.perPage}
							/>
						</div>
					</div>
				</div>
			);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
}
::-webkit-scrollbar {
	width: 7px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/DualTable.vue